import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-choose',
    templateUrl: './choose.component.html',
    styleUrls: ['./choose.component.scss'],
    standalone: false
})
export class ChooseComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ChooseComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { messages: string [] }
    ) {
    }

    ngOnInit(): void {
    }

}
